"use client";

import { c as _c } from "react/compiler-runtime";
import { Button } from "@/components/rac/button";
import { ArrowLeft } from "lucide-react";
interface MobileHeaderProps {
  title: string;
  subtitle?: string;
  onBack?: () => void;
  onTitleClick?: () => void;
  className?: string;
  disableBack?: boolean;
}
export function MobileHeader(t0) {
  const $ = _c(23);
  const {
    title,
    subtitle,
    onBack,
    onTitleClick,
    className,
    disableBack
  } = t0;
  const t1 = `bg-white ${className || ""}`;
  let t2;
  if ($[0] !== disableBack || $[1] !== onBack) {
    t2 = onBack ? <Button variant="ghost" size="sm" onPress={disableBack ? undefined : onBack} isDisabled={disableBack} className={`p-2 rounded-lg flex-shrink-0 transition-colors ${disableBack ? "opacity-40 cursor-not-allowed" : "hover:bg-neutral-100 active:bg-neutral-200 cursor-pointer"}`} aria-label="Go back"><ArrowLeft className="w-5 h-5 text-neutral-600" /></Button> : <div className="w-9 h-9 flex-shrink-0" />;
    $[0] = disableBack;
    $[1] = onBack;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = `flex items-center space-x-1 ${onTitleClick ? "cursor-pointer hover:text-primary-600 transition-colors" : ""}`;
  let t4;
  if ($[3] !== title) {
    t4 = <h1 className="text-lg font-semibold text-neutral-900 lg:text-xl truncate">{title}</h1>;
    $[3] = title;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== onTitleClick || $[6] !== t3 || $[7] !== t4) {
    t5 = <div className={t3} onClick={onTitleClick}>{t4}</div>;
    $[5] = onTitleClick;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== subtitle) {
    t6 = subtitle && <p className="text-sm text-neutral-600 hidden lg:block mt-0.5 truncate">{subtitle}</p>;
    $[9] = subtitle;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t5 || $[12] !== t6) {
    t7 = <div className="flex flex-col min-w-0 flex-1">{t5}{t6}</div>;
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t2 || $[15] !== t7) {
    t8 = <div className="flex items-center justify-between p-0 lg:p-4"><div className="flex items-center space-x-3 min-w-0 flex-1">{t2}{t7}</div></div>;
    $[14] = t2;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== subtitle) {
    t9 = subtitle && <div className="px-4 pb-4 lg:hidden border-b border-neutral-100"><p className="text-sm text-neutral-600 leading-relaxed">{subtitle}</p></div>;
    $[17] = subtitle;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t1 || $[20] !== t8 || $[21] !== t9) {
    t10 = <header className={t1}>{t8}{t9}</header>;
    $[19] = t1;
    $[20] = t8;
    $[21] = t9;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  return t10;
}